module.exports = __webpack_public_path__ + "media/images/creator/ogp-bff7d3adae5e8608ba96505c436d334e.png";